import { useEffect, useState } from 'react';
import moment from 'moment';
import { Timeline } from 'antd';
import { AppWatch } from '@wajeez/wajeez.microservices';
import { Select } from 'antd';
import { getWeekNumber, getDateOfWeek } from '@wajeez-web/core/utils';
import {
  useAppwatchSelector,
  useAppwatchDispatch,
  ContentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ChartHeader } from '@wajeez-web/modules/analysis';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

const UserDetailedRetuntionChart = ({
  userId,
  createdDate,
}: {
  userId: string;
  createdDate: string;
}) => {
  const dispatch = useAppwatchDispatch();
  const { userDetailedRetuntion, userDetailedRetuntionStatus } =
    useAppwatchSelector((c) => c.contentAnalysis);
  const [retentionPeriod, setRetentionPeriod] =
    useState<AppWatch.RetentionPeriod>(AppWatch.RetentionPeriod.Monthly);
  useEffect(() => {
    dispatch(
      ContentAnalysisActions.getuserDetailedRetuntionAfterRegistrationAsync({
        UserId: userId,
        RetentionPeriod: retentionPeriod,
      })
    );
  }, [retentionPeriod, userId]);

  const gettimeLineValue = () => {
    switch (retentionPeriod) {
      case AppWatch.RetentionPeriod.Monthly:
        return 'الشهر';
      case AppWatch.RetentionPeriod.Weekly:
        return ' الأسبوع';
      case AppWatch.RetentionPeriod.Daily:
        return 'اليوم';
      default:
        return 'الشهر';
    }
  };

  const getlabel = (
    item: AppWatch.UserDetailedRetentionAfterRegistrationOutput
  ) => {
    switch (retentionPeriod) {
      case AppWatch.RetentionPeriod.Monthly:
        return moment(
          new Date(
            new Date(createdDate).getFullYear(),
            (Number(item.from_created_date) || 0) +
              new Date(createdDate).getMonth(),
            new Date(createdDate).getDate()
          )
        )
          .locale('en')
          .format('YYYY-MM');
      case AppWatch.RetentionPeriod.Weekly:
        return moment(
          getDateOfWeek(
            getWeekNumber(new Date(createdDate)) +
              Number(item.from_created_date),
            new Date(createdDate).getFullYear()
          )
        )
          .locale('en')
          .format('YYYY-MM-DD');
      case AppWatch.RetentionPeriod.Daily:
        return moment(
          new Date(
            new Date(createdDate).getFullYear(),

            new Date(createdDate).getMonth(),
            new Date(createdDate).getDate() +
              (Number(item.from_created_date) || 0)
          )
        )
          .locale('en')
          .format('YYYY-MM-DD');
      default:
        return '';
    }
  };

  return (
    <div className="col-span-1">
      {' '}
      <Card>
        <div className="space-y-6  max-h-[700px]  overflow-y-auto  scrollbar-thin ">
          <div className="flex flex-row justify-between">
            <ChartHeader title="User Detailed Retention After Registration" />
            <Select
              className="w-32"
              value={retentionPeriod}
              onChange={(e) => {
                setRetentionPeriod(e);
              }}
              options={[
                {
                  label: 'Monthly',
                  value: AppWatch.RetentionPeriod.Monthly,
                },
                {
                  label: 'Weekly',
                  value: AppWatch.RetentionPeriod.Weekly,
                },
                {
                  label: 'Daily',
                  value: AppWatch.RetentionPeriod.Daily,
                },
              ]}
            />
          </div>
          {userDetailedRetuntionStatus === 'loading' ? (
            <div className="loading h-[300px] flex justify-center items-center align-middle">
              <div className="spinner-border text-primary" role="status">
                <span className="">
                  <ReturnTranslatedText text="general.Loading" />
                </span>
              </div>
            </div>
          ) : (
            <Timeline mode={'right'}>
              {userDetailedRetuntion?.map((item, index) => {
                return (
                  <Timeline.Item label={getlabel(item)}>
                    نشط في {gettimeLineValue()} ال{item.from_created_date}
                  </Timeline.Item>
                );
              })}
            </Timeline>
          )}
        </div>
      </Card>
    </div>
  );
};

export default UserDetailedRetuntionChart;
